<template>
  <div class="container-base" v-once>
    <div class="pages page-static">
      <div class="page-static-inner">
        <h1 style="font-size: 140%;">yagish이용규약</h1>
        <h2>제1조(규약의 적용)</h2>
        <p>「yagish(야기슈）이용규약」(이하,”본규약”)은 주식회사Yagish(이하,”당사”）가 제공하는 “yagish”서비스(이하”본서비스”라고 하고 제2조에서 정의)의 이용자(이하,”서비스 이용자”)가
          본서비스를 이용할 경우에 발생하는 모든 행위에 적용되는 것으로 하고 서비스 이용자는 본규약에 동의하고 본서비스를 이용하는 것으로 간주합니다.</p>

        <h2>제2조(서비스의 내용）</h2>
        <pre>본서비스는 이하의 기능으로 구성된 당사가 제공하는 서비스를 가르친다. 서비스 이용자가 입력한 이력서와 경력서의 작성 정보를 PDF파일로 출력하는 기능
본서비스의 이용 등록을 한 서비스 이용자가 자신의 메일어드레스에 상기1의 PDF파일을 송신하는 기능
서비스 이용등록을 한 서비스 이용자에 의한 정보 편집이력을 서버에 보존하고  서비스 이용자 자신이 임의로 과거의 편집이력을 복원할 수 있는 기능
당사 또는 당사와 별도 계규약계에 있는 제휴기업이 운영하는 타서비스로의 등록 기능
상기 4의 서비스에 대한 본서비스의 이용자 정보의 공유 기능
</pre>
        <h2>제3조(서비스의 이용)</h2>
        <pre>본서비스를 이용하는 경우 서비스 이용자는 본 규약에 동의해야 합니다. 인터넷에 접속해서 본서비스가 제공하는 웹사이트에 액세스할 필요가 있습니다. 본서비스를 이용하기 위해서는 이하의 환경이 필요합니다.
한국어가 이용 가능할 것
Cookie와 JavaScript가 이용 가능할 것
그외 당사가 지정하는 환경일 것
서비스 이용자는 스스로의 책임과 비용에 관해서 본서비스에 액세스 가능한 기기, 소프트웨어,환경을 준비해야 본서비스를 이용할 수 이용할 수 있습니다. 서비스 이용자는 당사가 제공하는 인터페이스 이외의 수단을 사용해서 본서비스에 액세스 해서는 안됩니다.
서비스 이용자는 스스로의 의사에 의해 본서비스를 이용하고 이용에 관련된 전책임을 지는 것을 원칙으로 합니다.
서비스 이용자는 본서비스의 이용에 있어서 고의 또는 과실에 의한 행위에 의해 제삼자에 대해 손해를 입혔을 경우 스스로의 책임으로 해결하고 당사는 어떠한 책임도 지지않습니다.
당사는 본서비스에 게재된 제휴기업의 정보의 정확성 합법성 유효성 그리고 그외의 사항에 대해서 감시 심사등의 관리에 관한 일절의 책임을 지지않는 것으로 합니다.
제휴기업의 등록내용 및 제휴기업으로부터 받은 정보에 대한 문의 및 대응은 정보제공원의 제휴기업에 일차적 책임이 있습니다. 	
</pre>
        <h2>제4조(yagish 이용 규약의 범위)</h2>
        <pre>본계약 이외에 당사가 별도 다음 각호의 사항(이하 “yagish 이용에 관한 고지사항")을 정한 경우에는 이것들도 본계약과 동등한 효력을 유하고 본서비스의 이용에도 적용되는 것으로 합니다.
“이용상의 주의” ,”안내”등 명칭의 여하를 묻지않고 본서비스의 이용방법에 관해서 본서비스의 웹사이트상에서 공지되는 이용상의 주의사항
전항외 회원의 자격,권리,yagish의 이용,그외 필요사항에 관해서 yagish의 웹사이트상에서 표시로서 안내되는 통지
전항의 yagish이용에 관한 공지사항은 특히 적용개시시기에 정하지 않는한 당사의 해당 공지사항을 사이트상에 표시하면 바로 효력 발생이 되고 동시에 회원의 승인이 있었다는 것으로 인정합니다. 이하 단순히 본계약의 경우에는 yagish이용에 관한 공지사항을 포함하는것으로 합니다.
</pre>
        <h2>제5조(서비스의 중단,중지등)</h2>
        <pre>당사는 당사의 판단에 의해 회원에게 사전 통지 및 승낙을 얻지 않아도 본서비스의 일부 또는 전부를 중단,중지,폐지,변경할 수 있습니다.또 본서비스의 중단, 중지, 폐지,변경으로 인해 회원에게 생긴 손해에 대해서 당사는 일절 책임이 없습니다.
        </pre>
  <h2>제6조(서비스 이용등록)</h2>
  <pre>서비스의 이용등록 희망자는 본계약을 준수할 것에 동의하고 당사가 정한 일정한 정보(이하 “등록정보")를 당사가 정한 방법으로 당사에 제공하는 것으로 본서비스의 이용등록을 신청하는 것으로 합니다.
전항의 신청은 서비스 이용등록 희망자 자신이 행하는 것으로 사실이고 정확한 최신의 정보를 당사에 제공하는 것으로 합니다.
당사는 본조항 1항에 기초로 서비스 이용등록을 신청한 등록 희망자가 이하의 각항에 이유에 해당하는 경우는 해당 등록 희망자의 서비스 이용등록을 사전 또는 사후에도 거부할 수 있는 것으로 합니다.
본규약에 위반될 가능성이 있거나  명확한 위반이 있다고 당사가 판단했을 경우
당사에 제공된 등록정보의 전부 또는 일부에 허위 중요한 오기 기재 누락이 있을 경우
과거에 본서비스의 서비스 이용 정지 처분을 받은 적이 있는 경우
그외 당사가 서비스 이용등록이 적당하지 않다고 판단한 경우
서비스 이용등록자는 당사가 본서비스를 제공함에 있어서 필요한 범위에서 다음과 같은 정보를 취득해서 제공하는 것에 동의합니다.
등록정보
본서비스를 이용할 때 서비스 이용등록자가 제공한 정보
본서비스에서는 서비스 이용자의 편의성 향상을 위해서 Google어카운트와 그외 제삼자가 운영하는 서비스 (이하 “외부 서비스")의 어카운트에 의해 서비스의 이용등록,로그인 기능을 제공합니다. 서비스의 이용등록자가 외부서비스의 어카운트에 의한 서비스의 이용등록 로그인할 경우 당사가 외부서비스에 등록된 서비스 이용등록자에 관한 정보를 취득할 수 있다는 것을 서비스 이용자가 승낙한 것으로 합니다.、또 외부 서비스에 제공한 정보에 대해서는 외부 서비스의 이용규약,프라이버시 폴리시에 따르게 됩니다만  당사가 취득한 정보에 대해서는 당사의 이용규약과 프라이버시 폴리시에 따를 것을 원칙으로 합니다.
</pre>
        <h2>제7조(서비스 이용자의 책무)</h2>
        <pre>서비스 이용자는 본서비스를 통해서 작성한 파일에 관한 일절의 책임을 지지않습니다.본서비스를 통해서 작성한 파일을 이용할 경우에는 내용의 신뢰성,정확성,완성도,유용성,바이러스의 유무등에 대해 각자가 판단해서 서비스 이용자의 책임과 리스크 부담을 전제로 이용해야 합니다.또 본서비스를 통해서 다음과 같은 행위를 금지합니다.
당사, 다른 서비스 이용자 또는 제삼자의 지적재산권의 침해
당사, 다른 서비스 이용자 또는 제삼자의 비방,중상
당사, 다른 서비스 이용자 또는 제삼자에게 불이익을 끼치는 행위
다른 서비스 이용자의 ID,패스워드를 부정으로 이용하는 행위
사회 미풍양속에 반하는 행위
법령에 위반되는 행위 또는 위반의 가능성이 있는 행위
본서비스를 통해서 받은 메일의 발신처를 위장하는 행위
본서비스 또는 본서비스에서 제공하는 기기나 네트워크를 방해하거나 무력화 시키는 행위
대량이나 대용량 파일을 불특정다수에 배포하고 당사가 제공하는 인플라 시스템등에 막대한 부담을 가한 행위
</pre>
        <h2>제8조(ID의 관리)</h2>
        <pre>서비스 이용자는 본서비스의 ID등(이하 “ID”)을 자기의 책임하에 적절하게 관리하고 등록정보의 내용이 최신이 되도록 이용자에게 적정 수정하는 의무를 지게 됩니다.
서비스 이용자는 어떠한 경우라도 ID를 제삼자에게 이용시키거나 대여 양도 명의변경 매매등을 해서는 안됩니다.
당사는 ID와 패스워드의 조합이 등록내용과 일치하게 로그인되는 경우에는 그 ID로 등록한 서비스 이용자에 의한 이용으로 보고 이것에 기초한 당사 및 제삼자에 발생한 손해 전부를 그 ID를 보유한 서비스 이용자에 부담시키는 것으로 합니다.
서비스 이용자는 ID가 부정으로 사용된 것을 알았을 경우 바로 그것을 당사에 연락해야 합니다.
ID이외의 등록정보에 변경이 생겼을 때는 서비스 이용자는 바로 마이페이지에 변경수속을 하고 등록정보에 부정확한 점이 있은 것이 판명된 경우에도 같은 처리합니다.
등록 어드레스에 변경이 생겼을때는 변경 수속 완료전에 당사가 변경전의 등록어드레스앞으로 송부한 메일은 유효하게 서비스 이용자에 송부된 건으로 간주합니다.
서비스 이용자는 ID의 도난 분실 부정사용 제삼자에 의한 무단사용등으로 인해 발생한 손해에 대해 일절 책임을 지거나 당사에 이것에 관한 책임을 요구할 수 없습니다..
</pre>
        <h2>제9조(작성한 파일의 처리)</h2>
        <pre>당사는 본서비스로 작성한 파일(이하 “본건 작성파일")에 관한 일절의 책임을 지지않습니다.
본서비스로 본건 작성파일의 백업은 서비스이용자 자신이 행하는 것으로 하고 본서비스에 보존한 데이터가 소멸한 경우에도 당사는 일절 책임을 지지 않습니다.
서비스 이용자는 본건 작성파일에 대해서 당사가 관여하지 않는 여러종류의 네트워크나 기기등을 경우하고 있다는 것을 이해하고 경우에 따라서는 본건 작성파일의 내용이 변경될 수 있는 가능성이 있는 점, 의도하지 않는 제삼자에 의한 열람 이용등이 있을 가능성이 있다는 것을 이해한 것을 전제로 본서비스를 이용하는 것으로 합니다.
</pre>
        <h2>제10조(본인 특정 정보의 비공개)</h2>
        <pre>당사는 서비스 이용자의 개인을 특정할 수 있는 항목의 정보(이름,주소,전화번호,메일어드레스의 정보가 이것에 해당하고 이하 “본인 특정 정보”)를 서비스 이용자의 승낙없이 제삼자에 공개하지 않는 것으로 합니다. 단 하기에 해당하는 경우에 제외하기로 합니다.
국가기관 또는 지방공공단체나 그 위탁을 받은자가 법령이 정하는 사무를 행하는 것에 대한 협력이 필요하고 서비스 이용자 자신의 동의를 얻은 것에 의해 그 사무를 수행하는 데 지장이 있을 수 있는 경우
서비스 이용자 자신 스스로가 제삼자(제휴기업을 포함)에게 정보제공을 요구할 경우
그외 서비스 이용자 자신에게 서비스를  제공하기 위해 필요하다고 당사가 판단한 경우
</pre>
        <h2>제11조(등록정보의 삭제)</h2>
        <pre>당사는 이하의 이유가 있을 경우에 서비스 이용자에게 사전에 통지하지않고 등록정보를 삭제할 수 있습니다.이 경우 당사가 등록정보를 삭제하고 본서비스를 이용할 수 없게 되는 경우에도 당사는 서비스 이용자에 대해 일절 책임을 지지않는 것으로 하겠습니다.또 본조항은 이하의 이유가 있을 경우에 등록정보를 삭제하는 것을 보증할 수 없습니다.
당사에서 보낸 메일이 등록된 메일어드레스로 연속해서 송신되지 않을 경우
서비스 이용자가 본규약을 위반한 경우
서비스 이용자에 의해 등록된 내용에 허위사항이 있다고 판단된 경우
서비스 이용자의 본서비스 최종이용부터 10년이 경과한 경우
그외 서비스 이용자가 본서비스를 이용하는데 적합하지 않다고 당사가 판단한 경우 
</pre>
        <h2>제12조(서비스 이용자로부터의 연락)</h2>
        <pre>본서비스에 관한 서비스 이용자로부터 당사에 연락이 필요한 경우에는 목적별로 문의 창구로 메일로 문의를 받습니다. 당사는 전화나 방문에 의한 연락은 받지 않습니다.
</pre>
        <h2>제13조(광고의 취급)</h2>
        <pre>서비스 이용자는 본서비스에 광고가 게재되는것이나 광고가 게재된 메일을 받는 것에 동의한 것으로 취급합니다. 메일을 포함한 본서비스에 게재된 광고나 선전의 내용에 관한 광고나 선전의 제공자(이하”광고주") 와 서비스 이용자와의 거래는 서비스 이용자와 해당 광고주가 책임지고 행하는 것으로 합니다.당사는본서비스에 게재된 광고에 의해 행해지는 거래로 기인하는 손해 및 책임은 일절 지지않습니다.
 </pre>
        <h2>제14조(서비스에 관한 무보증)</h2>
        <pre>당사는 본서비스의 내용과 제공의 상태,액세스의 가능성,사용의 상태에 대해서 일절의 보증을 하지 않습니다.문의의 회답등 서비스 이용자가 당사로부터 직접 또는 본서비스를 통해서 얻은 정보나 조언에 대해서도 서비스 이용자로부터 전달된 한정된 정보에 기초하고 있고 그 내용의 진위,적격성,정확성에 대해서 보증하지 않습니다.
 </pre>
        <h2>제15조(제휴기업의 등록,응모)</h2>
        <pre>본서비스는 당사의 제휴기업이 운영하는 각종서비스에 이용등록 또는 제휴기업이 제공하는 구인정보의 응모할 수 있는 서비스를 제공하고 있고 해당 이용등록 또는 응모는 이용자의 의사에 따라서 행해지는 것으로 합니다.
서비스 이용자는 전항의 이용등록 또는 응모를 희망하는 경우 당사로부터 제휴기업에 대해서 본서비스에 등록한 서비스 이용자 정보의 전부 또는 일부가 제공되는 것을 승낙하는 것으로 합니다.
전항에서 제휴기업에 재공되는 정보는 제휴기업의해 틀립니다.그리고 제휴기업에 서비스 이용자의 정보가 등록된것을 보증하는 것은 아닙니다.
</pre>
        <h2>제16조（면책사항）</h2>
        <pre>당사는 서비스 이용자가 본서비스를 이용, 또는 서비스의 이용 불가로 인한 서비스 이용자 또는 제삼자에게 발생한 일체의 손해에 대해 책임을 지지 않습니다. 여기에는 직접적, 간접적, 우발적, 예외적 및 결과적으로 징벌적 손해 (이익, 우호관계, 효용, 데이터 손실, 훼손, 열화, 도청, 누출 및 기타 무형 손실을 포함하지만 이에 국한되지 않음)등의 일체의 손해가 포함됩니다. 이것은 손해의 가능성에 관한 경고가 사전에 있었을 경우에도 적용됩니다.
</pre>
        <h2>제17조（쿠키）</h2>
        <pre>1.   본서비스에는 "쿠키(Cookie)"라는 기술을 사용하는 페이지가 있습니다. 본서비스의 웹페이지(이하 “본 웹사이트”라고 함) 상에 회원의 이메일을 표시하거나 회원 전용 서비스의 이용 상황 및 액세스 상황을 계측하여 기록, 분석하기 위해 쿠키를 이용하는 경우가 있습니다. 이 경우 당사는 상기 측정, 기록, 분석 이외의 목적으로 이용하지  않습니다.
2.  본 웹사이트에서 또는 본 웹사이트를 통해 제삼자가 제공하는 서비스(게재 광고 등의 제휴 프로그램이나 액세스 해석 등)에 액세스한 경우 해당 제삼자가 게재한 개인정보취급방침에 따라 쿠키나 웹비콘 등에 의해 정보 수집의 목적으로 이용자의 IP 주소, 방문 일시, 이용자 에이전트, 열람 경로 등의 정보가 자동으로 취득·제공되는 경우가 있습니다.
3.   서비스 이용자가 본 웹사이트 및 본 웹사이트를 통해 액세스한 제삼자가 제공하는 서비스에 쿠키에 의해 취득되는 정보를 제공하고 싶지 않은 경우에는 서비스 이용자가 쿠키 무효화에 의해 정보 제공을 거부할 수 있습니다.
</pre>
        <h2>제18조(통계 정보, 속성 정보, 이용 기록의 열람, 집계 및 이용)</h2>
        <pre>당사는 서비스 이용 등록, 말소의 전후를 불문하고, 본서비스를 이용하여 서비스 이용자가 등록한 서비스 이용자의 등록 정보 등, 본서비스의 이용 이력 및 이들을 특정의 개인을 식별 또는 식별하지 않음으로 해석한 후, 특정 개인을 식별할 수 없도록 가공, 집계 및 분석한 통계 데이터, 속성 정보 등을 작성하고, 해당 해석 결과, 이용 이력, 통계 데이터, 속성 정보 등에 대해 어떠한 제한 없이 이용(구인기업 또는 전직 에이전트에 열람하는 것, 구인 기업 또는 전직 에이전트에의 제안, 시장의 조사, 신서비스의 개발을 포함하지만, 이것에 한정되지 않음) 할 수 있으며 회원은 사전에 승낙합니다.
</pre>
        <h2>제19조(지적재산권）</h2>
        <pre>본서비스 및 본 웹사이트상에 게재되는 개별 문장, 도형, 디자인, 상표, 로고 마크 등에 관한 저작권, 상표권 기타 지적재산권은 당사에 저작권이 속하거나, 당사가 그 라이센스를 얻어 제공하고 있는 것입니다. 서비스 이용자는 저작권, 상표권 및 기타 지적재산권을 침해하지 않는다는 데 동의합니다.
</pre>
        <h2>제20조(규약의 변경）</h2>
        <pre>당사는 예고 없이 본 규약을 변경할 수 있습니다. 또한 본 규약이 변경되어 변경 후의 규약이 본서비스의 제공되고 있는 웹페이지에 게재된 때부터  변경 후의 내용이 적용됩니다.
</pre>
        <h2>제21조(본서비스의 내용 변경）</h2>
        <pre>당사는 예고없이 본서비스의 내용을 변경할 수 있으며, 서비스 이용자는 사전에 승낙한 것으로 간주합니다.
</pre>
        <h2>제22조(본서비스의 이용 정지）</h2>
        <pre>1.   서비스 이용자가 본서비스의 이용을 해제하는 경우는, 웹 페이지에서 별도 지정하는 소정의 방법으로 신청하는 것으로 합니다. 서비스 이용자가 해지한 경우, 해지와 동시에 본서비스의 이용을 종료하는 것으로 합니다.
2.  당사는 서비스 이용자가 본 규약을 위반한 경우, 당사가 부적절하다고 판단한 경우에는 사전에 통지하지 않고 본서비스의 이용을 정지할 수 있습니다.
</pre>
        <h2>제23조(비밀유지 및 서비스 이용자의 정보 보호）</h2>
        <pre>당사는 서비스 이용자의 정보를 이 규약에서 정하는 경우 외에 별도로 정하는 개인정보보호방침에 근거해 적절하게 취급합니다. 서비스 이용자는 본서비스를 이용 시 본 규약 및 개인정보보호방침에도 동의 하는 것으로 간주합니다. 또한 다음의 각 호에 정하는 사항에 대해서 서비스 이용자는 당사에 의한 서비스 이용자의 정보 이용 및 제공에 사전 동의합니다.
본서비스를 제공하기 위해
본서비스와 관련된 서비스 제공을 위해
전자우편을 통한 매거진,  광고 전송을 위해
설문조사 및 시장조사를 위해
회원가입, 탈퇴의 수속및 문의 답변을 위해
</pre>
        <h2>제24조(야기오퍼의 이용)</h2>
        <pre>1.  당사는 당사의  심사를 거쳐 본서비스에 이용 등록되어 있는 기업(이하 「서비스 등록 기업」이라고 한다)에 대해 서비스 이용자의 등록 정보 중 ★별표의 정보를 제공합니다.
2.  서비스 등록 기업은 전항의 정보에 관하여 서비스 이용자에게 연락을 취하고자 하는 경우에는 당사를 통해서 서비스 이용자에게 등록정보 공개의 승인을 요구합니다.
3.  서비스 이용자가 전항을 승인하면 서비스 이용자의 등록 정보의 상세 정보(별표의 정보에 추가로 이름, 생년월일, 주소, 전화 번호, 이메일)가 서비스 등록 기업에 공개 됩니다.
4.  서비스 등록 기업이 전항에 따라 서비스 이용자의 등록 정보의 제공을 받은 후, 서비스 이용자에게 설명회나 면접 등의 안내를 송부합니다(이하 「오퍼」라 함)라고 서비스 이용자는 「yagish 」마이페이지내의 「야기오퍼」의 기능을 이용 가능하게 됩니다.
5.  서비스 이용자의 본서비스 등록시에는 오퍼 수신 허가로 설정되어 있습니다. 서비스 등록 기업에 자신의 정보를 공개하고 싶지 않은 경우 및 오퍼의 수신을 거부하고 싶은 경우에는 마이페이지 내 「야기오퍼」에서 수신 거부에 체크를 하여 거부할 수 있습니다. 또한 오퍼 거부로부터 오퍼 수신 허가하는 경우에도 마찬가지로 체크를 해제하는 것으로 오퍼를 받을 수 있게 됩니다.
6.  서비스 이용자가 야기오퍼 기능을 이용 가능하게 된 후에도, 서비스 등록 업자의 사정이나 그 외의 이유에 의해 채팅 기능의 이력등이 소실되는 경우가 있습니다. 이 경우에 당사는 일체의 책임을 부담하지 않으므로 채팅 기능의 이력이나 그 외의 정보에 대해서는 당사자가 캡쳐를 보존하거나 하는 등으로 보관하는 것을 추천합니다.
</pre>
        <h2>제25조(분쟁의 해결)</h2>
        <pre>본 규약의 준거법은 일본법으로 합니다. 또한 본서비스 또는 본 규약과 관련하여 당사와 서비스 이용자간에 발생한 분쟁에 대해서는 도쿄지방법원을 제1심의 전속 합의관할법원으로 합니다.
</pre>
        <h2>제26조(협의)</h2>
        <pre>본 규약에 규정되어 있지 않은 사항에 대해서는 신의성실의 원칙에 따라 협의 해결 합니다.
</pre>
        <h2>★별표</h2>
          <h2>＜전직용・아르바이트용・파트타임용＞</h2>
          <pre>
이력서 작성일
학력·경력
면허·자격정보
지원 동기 · 특기 · 어필 포인트 등
본인 희망란
통근 시간
부양 가족 수
배우자 유무 및 배우자 부양 의무의 유무
해당자가 경력기술서를 작성한 경우에는 경력기술서의 이름을 제외한 모든 정보</pre>
          <h2>
            < 취업준비생용>
          </h2>
          <pre>
이력서 작성일
학력·경력
면허·자격정보
지원 동기 · 특기 · 어필 포인트 등
본인 희망란
통근 시간
부양 가족 수
배우자 유무 및 배우자 부양 의무의 유무
자기 PR
희망근무지, 희망업계, 지망직종
학부·학과·전공
졸업(예정) 연도
해당자가 경력기술서를 작성한 경우에는 경력기술서의 이름을 제외한 모든 정보</pre>
          <h2>
            <인턴용>
          </h2>
          <pre>
이력서 작성일
학력
면허·자격정보
자기 PR · 세미나 연구 · 특기과목 · 지망 동기 · 특기 · 어필 포인트 등
소개・추천
통근 시간
부양 가족 수
배우자 유무 및 배우자 부양 의무 유무
본인 희망란
해당자가 경력기술서를 작성한 경우에는 경력기술서의 이름을 제외한 모든 정보</pre>

          <p class="text-right">2018년 6월 28일 제정<br>
2021년 12월 3일 개정<br>
2023년 1월 5일 개정<br>
2023년 6월 1일 개정<br>
2023년 9월 4일 개정</p>
      </div>
    </div>


  </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () { }
}
</script>
